var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 5px;\n  font-family: \'Roboto\', sans-serif;\n  border-radius: 0.125rem;\n  // cursor: pointer;\n  ', ';\n  outline: none;\n  box-sizing: border-box;\n  background-position: 0;\n  background-color: ', ';\n  opacity: ', ';\n  border: 1px solid transparent;\n  box-shadow: 0 0 0 1px rgba(0,0,0,0.15);\n  vertical-align: top;\n\n  width: 11rem;\n  height: 11rem;\n  padding: 10px;\n\n  :hover {\n    background-color: #F7F9FA;\n  }\n\n  :active {\n    background-color: #EAF9F6;\n  }\n'], ['\n  margin: 5px;\n  font-family: \'Roboto\', sans-serif;\n  border-radius: 0.125rem;\n  // cursor: pointer;\n  ', ';\n  outline: none;\n  box-sizing: border-box;\n  background-position: 0;\n  background-color: ', ';\n  opacity: ', ';\n  border: 1px solid transparent;\n  box-shadow: 0 0 0 1px rgba(0,0,0,0.15);\n  vertical-align: top;\n\n  width: 11rem;\n  height: 11rem;\n  padding: 10px;\n\n  :hover {\n    background-color: #F7F9FA;\n  }\n\n  :active {\n    background-color: #EAF9F6;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  min-heightL 1.2em;\n  max-height: 2.4em;\n  font-size: 16px;\n'], ['\n  position: relative;\n  min-heightL 1.2em;\n  max-height: 2.4em;\n  font-size: 16px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: 2px 0;\n  font-size: 12px;\n  color: #7A7C7D;\n  height: 2.4em;\n'], ['\n  padding: 2px 0;\n  font-size: 12px;\n  color: #7A7C7D;\n  height: 2.4em;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n    position: absolute;\n    width: 9rem;\n    height: 9rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: -1;\n'], ['\n    position: absolute;\n    width: 9rem;\n    height: 9rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: -1;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  height: 5rem;\n'], ['\n  height: 5rem;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 13px;\n'], ['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 13px;\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { Component } from 'react';
import styled from 'styled-components';
import LinesEllipsis from 'react-lines-ellipsis';
import { ClipLoader } from 'react-spinners';

import NumericContent from './Numeric';

var GenericTile = styled.div(_templateObject, function (props) {
  return props.onClick && 'cursor: pointer';
}, function (props) {
  return props.loading ? '#F4F6F7' : "#FFF";
}, function (props) {
  return props.loading ? '0.3' : '1';
});

var Header = styled.div(_templateObject2);

var SubHeader = styled.div(_templateObject3);

var Loading = styled.div(_templateObject4);

var TileContent = styled.div(_templateObject5);

var Footer = styled.div(_templateObject6);

var linesEllipsisSettings = {
  ellipsis: '...',
  trimRight: true,
  basedOn: 'letters'
};

var ReactGenericTile = function (_Component) {
  _inherits(ReactGenericTile, _Component);

  function ReactGenericTile() {
    _classCallCheck(this, ReactGenericTile);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ReactGenericTile.prototype.render = function render() {
    var _props = this.props,
        header = _props.header,
        subheader = _props.subheader,
        footer = _props.footer,
        number = _props.number,
        scale = _props.scale,
        indicator = _props.indicator,
        loading = _props.loading,
        icon = _props.icon,
        size = _props.size,
        onClick = _props.onClick;
    var color = this.props.color;


    switch (color) {
      case 'Good':
        color = "#2b7c2b";
        break;
      case 'Warning':
        color = "#e78c07";
        break;
      case 'Bad':
        color = "#bb0000";
        break;
      default:
        break;
    }

    return React.createElement(
      GenericTile,
      {
        size: size,
        loading: loading,
        onClick: onClick
      },
      React.createElement(
        Loading,
        null,
        React.createElement(ClipLoader, {
          sizeUnit: "px",
          size: 44,
          color: '#123abc',
          loading: loading
        })
      ),
      React.createElement(
        Header,
        null,
        React.createElement(LinesEllipsis, _extends({
          text: header,
          maxLine: '2'
        }, linesEllipsisSettings))
      ),
      React.createElement(
        SubHeader,
        null,
        React.createElement(LinesEllipsis, _extends({
          text: subheader,
          maxLine: '2'
        }, linesEllipsisSettings))
      ),
      React.createElement(
        TileContent,
        null,
        React.createElement(NumericContent, { icon: icon, number: number, scale: scale, color: color, indicator: indicator })
      ),
      React.createElement(
        Footer,
        null,
        footer
      )
    );
  };

  return ReactGenericTile;
}(Component);

// <TileContent footer="Current Quarter" unit="EUR" class="sapUiSmallMargin">
//   <content>
//     <NumericContent scale="M" value="1.96"
//       valueColor="Error" indicator="Up" />
//   </content>
// </TileContent>

export { ReactGenericTile as default };
ReactGenericTile.defaultProps = {
  header: "",
  subheader: "",
  footer: "",
  loading: false,
  number: "",
  scale: "",
  color: "#000",
  indicator: null,
  icon: null,
  size: "Normal"
};